export const WHITEBOARD_EXPORT_MIME = "image/png";
export const WHITEBOARD_EXPORT_FILENAME = "whiteboard.png";

/** Build a readable, path-safe dated filename for a board export. */
export function whiteboardExportFilename(title: string, date = new Date()): string {
  const readableTitle = title
    .normalize("NFC")
    .replace(/[^\p{L}\p{N} _-]+/gu, " ")
    .trim()
    .replace(/[ _-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80)
    .replace(/-+$/g, "");
  const safeTitle = readableTitle || "whiteboard";
  return `${safeTitle}_${date.toISOString().slice(0, 10)}.png`;
}

/**
 * Canvas CSS backgrounds are not bitmap pixels.  Start the saved-board export
 * with an opaque white layer so image viewers (including iOS) never choose a
 * dark background for transparent board space.
 */
export function createOpaqueWhiteboardExportCanvas(
  width: number,
  height: number,
  createCanvas: () => HTMLCanvasElement = () => document.createElement("canvas")
) {
  const canvas = createCanvas();
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Could not create export canvas");

  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, width, height);
  return { canvas, context };
}

export function canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) reject(new Error("Could not export image"));
      else resolve(blob);
    }, WHITEBOARD_EXPORT_MIME);
  });
}
